import widgetInfo from './widgetInfo';
import account from './account';
import wisVehicle from './wis-vehicle';
import pricingModuleData from './pricingModule';
import userProfile from './userProfile';
import showCollapsedPricingForDr from './showCollapsedPricingForDr';

const root = {
	widgetInfo,
	account,
	pricingModuleData,
	userProfile,
	wisVehicle,
	showCollapsedPricingForDr
};

export default root;
